import type { FunctionComponent } from 'react';

/**
 * ListRowDetailsItemBadge is a small little badge component,
 * generally used for displaying counts.
 */
const ListRowDetailsItemBadge: FunctionComponent = ({ children }) => (
  <span className="fossa-list__row__details__item__trailing__badge">
    {children}
  </span>
);

export default ListRowDetailsItemBadge;
